
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_6360_8188)"}},[_c('path',{attrs:{"d":"M31.025 6.8H25.5V4.675c0-.706-.568-1.275-1.275-1.275H9.775C9.07 3.4 8.5 3.97 8.5 4.675V6.8H2.975C2.27 6.8 1.7 7.37 1.7 8.075v2.975c0 1.897 1.196 3.847 3.289 5.35 1.673 1.206 3.708 1.971 5.843 2.215 1.668 2.768 3.618 3.91 3.618 3.91v3.825H11.9c-1.875 0-3.4 1.1-3.4 2.975v.638c0 .35.287.637.638.637h15.725a.64.64 0 00.637-.637v-.638c0-1.875-1.524-2.975-3.4-2.975h-2.55v-3.825s1.95-1.142 3.618-3.91c2.14-.244 4.176-1.009 5.844-2.215 2.088-1.503 3.288-3.453 3.288-5.35V8.075c0-.706-.568-1.275-1.275-1.275zm-24.05 6.843C5.68 12.708 5.1 11.667 5.1 11.05v-.85h3.41a19.08 19.08 0 00.68 4.58 8.564 8.564 0 01-2.214-1.137zM28.9 11.05c0 .856-.94 1.918-1.875 2.593a8.599 8.599 0 01-2.22 1.137c.371-1.328.626-2.848.68-4.58H28.9v.85z","fill":"#FAC403"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_6360_8188"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(1.7 3.4)","d":"M0 0h30.6v27.2H0z"}})])])])
          )
        }
      }
    